import { render, staticRenderFns } from "./UsefulLinks.vue?vue&type=template&id=48d63a8c&"
import script from "./UsefulLinks.vue?vue&type=script&lang=js&"
export * from "./UsefulLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports